/**
 * @generated SignedSource<<f61e34514b1e00071dce966dba8a1ddd>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type scenarioModal_AtlassianConversationAssistantAgent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef">;
  readonly " $fragmentType": "scenarioModal_AtlassianConversationAssistantAgent";
};
export type scenarioModal_AtlassianConversationAssistantAgent$key = {
  readonly " $data"?: scenarioModal_AtlassianConversationAssistantAgent$data;
  readonly " $fragmentSpreads": FragmentRefs<"scenarioModal_AtlassianConversationAssistantAgent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "scenarioModal_AtlassianConversationAssistantAgent",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "knowledgeSection_AtlassianConversationAssistantAgent_AgentKnowledgeSection_scenarioRef"
    }
  ],
  "type": "AgentStudioScenario",
  "abstractKey": "__isAgentStudioScenario"
};

(node as any).hash = "3123798e047c7045dc5c59f62922fbcd";

export default node;
